import { ApiClient } from '../../gateway/api';
import { BaseExtension, defaultDispose } from '../extension-manager';
import { RegistryExtension } from '../registry-extension';
import { crowdsourcedTranscription } from './templates/crowdsourced-transcription';
import { customProject } from './templates/custom-project';
import { metadataSuggestions } from './templates/metadata-suggestions';
import { ocrCorrection } from './templates/ocr-correction';
import { ProjectTemplate } from './types';
import { tabularProject } from './templates/tabular-project';

export class ProjectTemplateExtension extends RegistryExtension<ProjectTemplate> implements BaseExtension {
  api: ApiClient;

  static REGISTRY = 'project-template';

  constructor(api: ApiClient) {
    super({
      registryName: ProjectTemplateExtension.REGISTRY,
    });
    this.api = api;
  }

  dispose() {
    defaultDispose(this);
    super.dispose();
  }

  static register(definition: ProjectTemplate) {
    RegistryExtension.emitter.emit(ProjectTemplateExtension.REGISTRY, definition);
  }

  static removePlugin(event: { pluginId: string; siteId?: number; type: string }) {
    RegistryExtension.emitter.emit(`remove-plugin-${ProjectTemplateExtension.REGISTRY}`, event);
  }

  static registerPlugin(event: { pluginId: string; siteId?: number; definition: ProjectTemplate }) {
    RegistryExtension.emitter.emit(`plugin-${ProjectTemplateExtension.REGISTRY}`, event);
  }
}

// Register built-ins once; each client replays the current registry.
ProjectTemplateExtension.register(metadataSuggestions);
ProjectTemplateExtension.register(customProject);
ProjectTemplateExtension.register(crowdsourcedTranscription);
ProjectTemplateExtension.register(ocrCorrection);
ProjectTemplateExtension.register(tabularProject);
